import React, { useState } from "react";

const FAQcard = ({ ques, ans, id, heading, isOpen, setIsOpen }) => {
  //   const [isOpen, setisOpen] = useState(heading + "0" || "");
  return (
    <div className="border first:rounded-t-md last:rounded-b-md overflow-hidden">
      <div
        className={`flex justify-between items-center  py-3 px-4 cursor-pointer border-b bg-back dark:dark-bg-back`}
        onClick={() =>
          setIsOpen((prev) => (heading + id === prev ? "" : heading + id))
        }
      >
        <h3 className="text-xl font-light">{ques}</h3>
        <span
          className={`${
            isOpen === heading + id ? "rotate-0" : "rotate-90"
          } duration-300`}
        >
          {isOpen === heading + id ? (
            <i className="fa fa-minus" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-plus" aria-hidden="true"></i>
          )}
        </span>
      </div>
      <div
        className={` px-3 transition-all duration-300 ${
          isOpen === heading + id ? "h-auto pt-3 pb-14" : "h-0 pb-0 pt-0"
        } `}
      >
        {ans}
      </div>
    </div>
  );
};

export default FAQcard;
